export default __webpack_public_path__ + "static/rift_bold-f4cd06201f6852d2056f921d20047d63.otf";